export const stripUrlScheme = (value: string): string => value.replace(/^https?:\/\//i, '');

// Treats empty, whitespace, or a bare `https://` as "no URL provided". Used
// alongside inputs that keep `https://` as a non-removable prefix.
export const isEmptyUrl = (value: string | null | undefined): boolean => {
  const trimmed = value?.trim() ?? '';
  return trimmed === '' || trimmed === 'https://';
};

// Normalizes user-entered URLs so they always start with `https://`. The host
// is preserved as typed — short-domain sites like `http.cat` do not resolve
// under `www.`, so we never inject a `www.` prefix.
export const normalizeUrl = (raw: string): string => {
  const withoutScheme = stripUrlScheme(raw.trim());
  return withoutScheme ? `https://${withoutScheme}` : '';
};
